(() => {
const roots = Array.from(document.querySelectorAll('[data-pdl-desktop-header]'));
roots.forEach((root) => {
if (root.dataset.pdlReady === 'true') return;
root.dataset.pdlReady = 'true';
const desktopQuery = window.matchMedia('(min-width: 1000px)');
const toggles = Array.from(root.querySelectorAll('[data-pdl-menu-toggle]'));
const slides = Array.from(root.querySelectorAll('[data-pdl-notice-slide]'));
const prevButton = root.querySelector('[data-pdl-notice-prev]');
const nextButton = root.querySelector('[data-pdl-notice-next]');
const cartTrigger = root.querySelector('.pdl-dh__cart');
const TOP_THRESHOLD = 3;
const HIDE_AFTER = 28;
const REVEAL_AFTER = 18;
const NOISE_DELTA = 2;
const STATE_LOCK_MS = 240;
let currentSlide = 0;
let noticeTimer = null;
let lastY = Math.max(window.scrollY || 0, 0);
let scrollDirection = null;
let directionAnchorY = lastY;
let stateLockedUntil = 0;
let stateUnlockTimer = null;
let scrollTicking = false;
let nativeCartDrawer = null;
let nativeCartDrawerParent = null;
let nativeCartDrawerNextSibling = null;
let nativeCartDrawerTrigger = null;
let nativeCartDrawerTriggerDisplay = '';
let nativeCartDrawerTriggerHadHidden = false;
let nativeCartDrawerTriggerAriaHidden = null;
let nativeCartDrawerTriggerTabindex = null;

const closeMenus = (exceptButton) => {
toggles.forEach((button) => {
if (button === exceptButton) return;
button.setAttribute('aria-expanded', 'false');
const panelId = button.getAttribute('aria-controls');
const panel = panelId ? document.getElementById(panelId) : null;
if (panel) panel.hidden = true;
});
};

const findNativeCartDrawer = () => {
if (nativeCartDrawer && nativeCartDrawer.isConnected) return nativeCartDrawer;
const originalHeader = document.querySelector('header-component#header-component');
const drawer = originalHeader
? originalHeader.querySelector('cart-drawer-component')
: document.querySelector('cart-drawer-component');
if (!drawer) return null;
nativeCartDrawer = drawer;
if (!nativeCartDrawerParent) {
nativeCartDrawerParent = drawer.parentNode;
nativeCartDrawerNextSibling = drawer.nextSibling;
}
return drawer;
};

const hideNativeDrawerTrigger = (drawer) => {
if (!nativeCartDrawerTrigger) {
nativeCartDrawerTrigger = drawer.querySelector('[data-testid="cart-drawer-trigger"]');
if (nativeCartDrawerTrigger) {
nativeCartDrawerTriggerDisplay = nativeCartDrawerTrigger.style.display;
nativeCartDrawerTriggerHadHidden = nativeCartDrawerTrigger.hasAttribute('hidden');
nativeCartDrawerTriggerAriaHidden = nativeCartDrawerTrigger.getAttribute('aria-hidden');
nativeCartDrawerTriggerTabindex = nativeCartDrawerTrigger.getAttribute('tabindex');
}
}
if (!nativeCartDrawerTrigger) return;
nativeCartDrawerTrigger.hidden = true;
nativeCartDrawerTrigger.setAttribute('aria-hidden', 'true');
nativeCartDrawerTrigger.setAttribute('tabindex', '-1');
nativeCartDrawerTrigger.style.display = 'none';
};

const localizeNativeCartDrawerTitle = (drawer) => {
const heading = drawer.querySelector('#cart-drawer-heading');
if (!heading) return;
const titleNode = Array.from(heading.childNodes).find(
(node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
);
if (titleNode && titleNode.textContent.trim() !== 'Carrinho') {
titleNode.textContent = 'Carrinho ';
}
};

const prepareNativeCartDrawer = () => {
const drawer = findNativeCartDrawer();
if (!drawer) return null;
hideNativeDrawerTrigger(drawer);
localizeNativeCartDrawerTitle(drawer);
if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
drawer.setAttribute('data-pdl-detached-cart-drawer', 'true');
return drawer;
};

const restoreNativeCartDrawer = () => {
if (!nativeCartDrawer || !nativeCartDrawerParent || !nativeCartDrawerParent.isConnected) return;
if (nativeCartDrawer.parentNode !== nativeCartDrawerParent) {
if (nativeCartDrawerNextSibling && nativeCartDrawerNextSibling.parentNode === nativeCartDrawerParent) {
nativeCartDrawerParent.insertBefore(nativeCartDrawer, nativeCartDrawerNextSibling);
} else {
nativeCartDrawerParent.appendChild(nativeCartDrawer);
}
}
nativeCartDrawer.removeAttribute('data-pdl-detached-cart-drawer');
if (!nativeCartDrawerTrigger) return;
nativeCartDrawerTrigger.style.display = nativeCartDrawerTriggerDisplay;
if (nativeCartDrawerTriggerHadHidden) {
nativeCartDrawerTrigger.setAttribute('hidden', '');
} else {
nativeCartDrawerTrigger.removeAttribute('hidden');
}
if (nativeCartDrawerTriggerAriaHidden === null) {
nativeCartDrawerTrigger.removeAttribute('aria-hidden');
} else {
nativeCartDrawerTrigger.setAttribute('aria-hidden', nativeCartDrawerTriggerAriaHidden);
}
if (nativeCartDrawerTriggerTabindex === null) {
nativeCartDrawerTrigger.removeAttribute('tabindex');
} else {
nativeCartDrawerTrigger.setAttribute('tabindex', nativeCartDrawerTriggerTabindex);
}
};

const bindNativeCartDrawerLifecycle = (drawer) => {
const dialog = drawer?.querySelector('dialog[ref="dialog"]');
if (!dialog || dialog.dataset.pdlRestoreOnClose === 'true') return;
dialog.dataset.pdlRestoreOnClose = 'true';
dialog.addEventListener('close', () => {
window.requestAnimationFrame(() => restoreNativeCartDrawer());
});
};

const getCartSectionHtmlFromEvent = (event, sectionId) => {
if (!sectionId) return null;
return (
event?.detail?.data?.sections?.[sectionId] ||
event?.detail?.resource?.sections?.[sectionId] ||
null
);
};

const syncDetachedCartDrawerFromSectionHtml = (sectionHtml) => {
if (
!sectionHtml ||
!nativeCartDrawer ||
!nativeCartDrawer.isConnected ||
nativeCartDrawer.getAttribute('data-pdl-detached-cart-drawer') !== 'true'
) return;

const currentItems = nativeCartDrawer.querySelector('cart-items-component[data-drawer]');
const currentDialog = nativeCartDrawer.querySelector('dialog[ref="dialog"]');
if (!currentItems || !currentDialog) return;

const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
const freshDrawer = parsed.querySelector('cart-drawer-component');
const freshItems = freshDrawer?.querySelector('cart-items-component[data-drawer]');
const freshDialog = freshDrawer?.querySelector('dialog[ref="dialog"]');
if (!freshItems) return;

const nextChildren = Array.from(freshItems.childNodes, (node) => node.cloneNode(true));
currentItems.replaceChildren(...nextChildren);

if (freshDialog) {
currentDialog.classList.toggle(
'cart-drawer__dialog--empty',
freshDialog.classList.contains('cart-drawer__dialog--empty')
);
}

localizeNativeCartDrawerTitle(nativeCartDrawer);

customElements.whenDefined('cart-quantity-selector-component').then(() => {
nativeCartDrawer?.querySelectorAll('cart-quantity-selector-component').forEach((selector) => {
if (typeof selector.updateButtonStates === 'function') selector.updateButtonStates();
});
});
};

const syncDetachedCartDrawerOnCartEvent = (event) => {
if (
!nativeCartDrawer ||
nativeCartDrawer.getAttribute('data-pdl-detached-cart-drawer') !== 'true'
) return;

const cartItems = nativeCartDrawer.querySelector('cart-items-component[data-drawer]');
const sectionId = cartItems?.dataset?.sectionId || event?.detail?.sourceId;
const sectionHtml = getCartSectionHtmlFromEvent(event, sectionId);
if (!sectionHtml) return;

window.requestAnimationFrame(() => {
if (
!nativeCartDrawer ||
nativeCartDrawer.getAttribute('data-pdl-detached-cart-drawer') !== 'true'
) return;
syncDetachedCartDrawerFromSectionHtml(sectionHtml);
});
};

document.addEventListener('cart:update', syncDetachedCartDrawerOnCartEvent);
document.addEventListener('discount:update', syncDetachedCartDrawerOnCartEvent);

toggles.forEach((button) => {
button.addEventListener('click', (event) => {
event.preventDefault();
const panelId = button.getAttribute('aria-controls');
const panel = panelId ? document.getElementById(panelId) : null;
if (!panel) return;
const willOpen = button.getAttribute('aria-expanded') !== 'true';
closeMenus(button);
button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
panel.hidden = !willOpen;
});
});

document.addEventListener('click', (event) => {
if (!root.contains(event.target)) closeMenus();
});
document.addEventListener('keydown', (event) => {
if (event.key === 'Escape') closeMenus();
});

if (cartTrigger) {
cartTrigger.addEventListener('click', (event) => {
if (!desktopQuery.matches) return;
const drawer = prepareNativeCartDrawer();
if (!drawer) return;
bindNativeCartDrawerLifecycle(drawer);
event.preventDefault();
closeMenus();
customElements.whenDefined('cart-drawer-component').then(() => {
const activeDrawer = prepareNativeCartDrawer() || drawer;
bindNativeCartDrawerLifecycle(activeDrawer);
if (activeDrawer && typeof activeDrawer.open === 'function') {
localizeNativeCartDrawerTitle(activeDrawer);
activeDrawer.open();
return;
}
window.location.href = cartTrigger.href;
});
});
}

const showSlide = (index) => {
if (!slides.length) return;
currentSlide = (index + slides.length) % slides.length;
slides.forEach((slide, slideIndex) => {
slide.classList.toggle('is-active', slideIndex === currentSlide);
});
};
const restartNoticeTimer = () => {
if (noticeTimer) window.clearInterval(noticeTimer);
if (slides.length > 1) {
noticeTimer = window.setInterval(() => showSlide(currentSlide + 1), 5200);
}
};
if (prevButton) {
prevButton.addEventListener('click', () => {
showSlide(currentSlide - 1);
restartNoticeTimer();
});
}
if (nextButton) {
nextButton.addEventListener('click', () => {
showSlide(currentSlide + 1);
restartNoticeTimer();
});
}
showSlide(0);
restartNoticeTimer();

const resetScrollTracking = (currentY = Math.max(window.scrollY || 0, 0)) => {
lastY = currentY;
scrollDirection = null;
directionAnchorY = currentY;
stateLockedUntil = 0;
if (stateUnlockTimer) {
window.clearTimeout(stateUnlockTimer);
stateUnlockTimer = null;
}
};

const setScrollState = (nextState, currentY, now) => {
if (root.dataset.scrollState === nextState) return false;
root.dataset.scrollState = nextState;
if (nextState === 'down') closeMenus();
stateLockedUntil = now + STATE_LOCK_MS;
scrollDirection = null;
directionAnchorY = currentY;
lastY = currentY;
if (stateUnlockTimer) window.clearTimeout(stateUnlockTimer);
stateUnlockTimer = window.setTimeout(() => {
stateUnlockTimer = null;
const settledY = Math.max(window.scrollY || 0, 0);
lastY = settledY;
scrollDirection = null;
directionAnchorY = settledY;
}, STATE_LOCK_MS + 30);
return true;
};

const updateScrollState = () => {
scrollTicking = false;
const currentY = Math.max(window.scrollY || 0, 0);

if (!desktopQuery.matches) {
if (root.dataset.scrollState !== 'top') root.dataset.scrollState = 'top';
resetScrollTracking(currentY);
return;
}

const now = window.performance && typeof window.performance.now === 'function'
? window.performance.now()
: Date.now();

if (currentY <= TOP_THRESHOLD) {
if (!setScrollState('top', currentY, now)) {
lastY = currentY;
scrollDirection = null;
directionAnchorY = currentY;
}
return;
}

if (now < stateLockedUntil) {
lastY = currentY;
scrollDirection = null;
directionAnchorY = currentY;
return;
}

const delta = currentY - lastY;
if (Math.abs(delta) < NOISE_DELTA) return;

const nextDirection = delta > 0 ? 'down' : 'up';
if (nextDirection !== scrollDirection) {
scrollDirection = nextDirection;
directionAnchorY = lastY;
}

const travelled = Math.abs(currentY - directionAnchorY);
if (
scrollDirection === 'down' &&
travelled >= HIDE_AFTER &&
root.dataset.scrollState !== 'down'
) {
setScrollState('down', currentY, now);
return;
}

if (
scrollDirection === 'up' &&
travelled >= REVEAL_AFTER &&
root.dataset.scrollState !== 'up'
) {
setScrollState('up', currentY, now);
return;
}

lastY = currentY;
};

const requestScrollUpdate = () => {
if (scrollTicking) return;
scrollTicking = true;
window.requestAnimationFrame(updateScrollState);
};

window.addEventListener('scroll', requestScrollUpdate, { passive: true });
const handleDesktopChange = () => {
if (!desktopQuery.matches) restoreNativeCartDrawer();
resetScrollTracking();
updateScrollState();
closeMenus();
};
if (typeof desktopQuery.addEventListener === 'function') {
desktopQuery.addEventListener('change', handleDesktopChange);
} else if (typeof desktopQuery.addListener === 'function') {
desktopQuery.addListener(handleDesktopChange);
}
updateScrollState();
});
})();

(() => {
const isPlainLeftClick = (event) => (
event.button === 0 &&
!event.metaKey &&
!event.ctrlKey &&
!event.shiftKey &&
!event.altKey
);

document.querySelectorAll('[data-pdl-desktop-header]').forEach((root) => {
if (root.dataset.pdlMegaLinksReady === 'true') return;
root.dataset.pdlMegaLinksReady = 'true';

root.addEventListener('click', (event) => {
if (!isPlainLeftClick(event)) return;
const link = event.target.closest('.pdl-dh__submenu a[href]');
if (!link || !root.contains(link)) return;
const href = link.href;
if (!href || href.endsWith('#')) return;
event.preventDefault();
event.stopImmediatePropagation();
window.location.assign(href);
}, true);
});
})();
/* pdl-compat-copy-v1: copy and visual hierarchy for the compatibility tool */
(() => {
  const applyCompatibilityCopy = () => {
    document.querySelectorAll('[data-pdl-compat-highlight]').forEach((card) => {
      const title = card.querySelector('.pdl-dh__compat-card strong');
      const description = card.querySelector('[data-pdl-compat-description]');
      const cta = card.querySelector('[data-pdl-compat-cta] span');
      if (title) title.textContent = 'Ferramenta de compatibilidade';
      if (description) description.textContent = 'Aqui você informa o modelo e o ano do seu carro e obtém os racks e transbikes compatíveis com seu carro.';
      if (cta) cta.textContent = 'Clique e acesse';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCompatibilityCopy, { once: true });
  } else {
    applyCompatibilityCopy();
  }
})();
